import styled from 'styled-components'
import { breakpoints } from '@/styles'

const FilterTextWrapper = styled.span`
  span {
    margin-left: 4px;
  }
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    span {
      margin: 0;
      display: inline-block;
    }
  }
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    min-width: 55px;
    font-size: 16px;
    display: inline-block;
  }
`
export default FilterTextWrapper
